import { Timestamp } from 'firebase/firestore';

export interface Tag {
  id: string;
  name: string;
  color: string;
  description?: string;
  userId: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  usageCount: number;
  isSystem?: boolean; // System tags that can't be deleted
}

export interface TagUsage {
  tagId: string;
  tagName: string;
  contactCount: number;
  lastUsed: Timestamp;
}

export interface TagFilter {
  tagIds: string[];
  operator: 'AND' | 'OR'; // AND = contact must have ALL tags, OR = contact must have ANY tag
}

export interface BulkTagOperation {
  contactIds: string[];
  tagIds: string[];
  operation: 'add' | 'remove' | 'replace';
}

// Predefined tag colors
export const TAG_COLORS = [
  { name: 'Blue', value: '#3B82F6' },
  { name: 'Green', value: '#10B981' },
  { name: 'Purple', value: '#8B5CF6' },
  { name: 'Pink', value: '#EC4899' },
  { name: 'Orange', value: '#F59E0B' },
  { name: 'Red', value: '#EF4444' },
  { name: 'Indigo', value: '#6366F1' },
  { name: 'Teal', value: '#14B8A6' },
  { name: 'Yellow', value: '#EAB308' },
  { name: 'Gray', value: '#6B7280' },
  { name: 'Emerald', value: '#059669' },
  { name: 'Cyan', value: '#06B6D4' },
  { name: 'Violet', value: '#7C3AED' },
  { name: 'Rose', value: '#F43F5E' },
  { name: 'Lime', value: '#84CC16' },
  { name: 'Amber', value: '#F59E0B' },
] as const;

// System tags that are created automatically
export const SYSTEM_TAGS = [
  { name: 'Newsletter', color: '#3B82F6', description: 'Subscribed to newsletter' },
  { name: 'VIP', color: '#8B5CF6', description: 'High-value customer' },
  { name: 'Trial', color: '#F59E0B', description: 'Free trial user' },
  { name: 'Churned', color: '#6B7280', description: 'Former customer' },
  { name: 'Premium', color: '#10B981', description: 'Premium plan user' },
] as const;
